/**
 * Generated template: Movies & TV Shows
 * Auto-generated by scripts/generate-templates.js - DO NOT EDIT
 */

import { TierListTemplate, Tier } from "@/types/tier-list";
import { TemplateMetadata } from "@/types/template-metadata";

/**
 * Template metadata (available immediately, no images loaded)
 */
export const metadata: TemplateMetadata = {
  id: "movies",
  displayName: "Movies & TV Shows",

  description: "Rate your favorite movies and TV shows",
  tiers: [
  {
    "id": "tier-masterpiece",
    "label": "Masterpiece",
    "priority": 0,
    "color": {
      "label": "#000000",
      "background": "#FCD34D"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-excellent",
    "label": "Excellent",
    "priority": 1,
    "color": {
      "label": "#FFFFFF",
      "background": "#7C3AED"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-great",
    "label": "Great",
    "priority": 2,
    "color": {
      "label": "#FFFFFF",
      "background": "#2563EB"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-good",
    "label": "Good",
    "priority": 3,
    "color": {
      "label": "#FFFFFF",
      "background": "#16A34A"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-average",
    "label": "Average",
    "priority": 4,
    "color": {
      "label": "#FFFFFF",
      "background": "#EA580C"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-below-average",
    "label": "Below Average",
    "priority": 5,
    "color": {
      "label": "#FFFFFF",
      "background": "#DC2626"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-unwatchable",
    "label": "Unwatchable",
    "priority": 6,
    "color": {
      "label": "#FFFFFF",
      "background": "#64748B"
    },
    "fontSizeMultiplier": 2
  }
] as Tier[],
  hasItems: false,
};

/**
 * Load full template with all data including images
 * This is lazy-loaded only when the template is selected
 */
export async function loadFull(): Promise<TierListTemplate> {
  // Dynamic import loads the full JSON only when called
  const fullTemplate = await import("@/templates/movies.json");
  return fullTemplate.default as TierListTemplate;
}
